/**
 * Created by Youhn on 2017/9/11.
 */
let NullToEmpty = (from, to) => {
  if (from === null || from === 'null' || from === 'undefined') {
    return typeof to === 'undefined' ? '' : to
  }
  return from
}
let _q = (c, b) => {
  if (b && typeof b === 'string') {
    try {
      b = _q(b)
    } catch (e) {
      console.log(e)
      return
    }
  }
  return (b || document).querySelector(c)
}
let _qAll = (c, b) => {
  if (b && typeof b === 'string') {
    try {
      b = _q(b)
    } catch (e) {
      console.log(e)
      return
    }
  }
  return (b || document).querySelectorAll(c)
}
let _doUrl = (a) => {
  var c = location.search
  var e = {}
  if (c.indexOf('?') !== -1) {
    var f = c.substr(1)
    var strs = f.split('&')
    for (var d = 0; d < strs.length; d += 1) {
      e[strs[d].split('=')[0]] = decodeURIComponent(strs[d].split('=')[1])
    }
  }
  a.call(e)
}
let format = (date, fmt = 'yyyy-MM-dd HH:mm:ss') => {
  date = String(date)
  if (typeof date === 'string') {
    date = new Date(date.replace(/-/g, '/'))
  }
  if (typeof date === 'number') {
    date = new Date(date)
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours() % 12 === 0 ? 12 : date.getHours() % 12,
    'H+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth() + 3) / 3),
    'S': date.getMilliseconds()
  }
  let week = {
    '0': '\u65e5',
    '1': '\u4e00',
    '2': '\u4e8c',
    '3': '\u4e09',
    '4': '\u56db',
    '5': '\u4e94',
    '6': '\u516d'
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  if (/(E+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, ((RegExp.$1.length > 1) ? (RegExp.$1.length > 2 ? '\u661f\u671f' : '\u5468') : '') + week[date.getDay() + ''])
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}
let dateByStamp = (timer, fmt) => {
  if (typeof fmt === 'undefined') {
    return timer
  } else {
    return format(timer, fmt)
  }
}
let removeDuplicatedItem = (arr) => {
  let result = []
  let hash = {}
  for (var i = 0, elem; (elem = arr[i]) != null; i++) {
    if (!hash[elem.resourcekind]) {
      result.push(elem)
      hash[elem.resourcekind] = true
    }
  }
  return result
}
let isNullOrEmpty = (str) => {
  if (str === '' || str === 'null' || str === null) {
    return false
  }
  return true
}
export {
  NullToEmpty, _q, _qAll, _doUrl, format, dateByStamp, removeDuplicatedItem, isNullOrEmpty
}



// WEBPACK FOOTER //
// ./src/util/util.js